module.exports = __webpack_public_path__ + "img/accounts.weekly.3d4ff994.png";